export default __webpack_public_path__ + "static/media/camp.a1935e29.png";